module.exports = __webpack_public_path__ + "static/media/machine.b187b9b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/machine.jpg
// module id = 767
// module chunks = 0